import { useRef } from 'react';

import type { useListState } from '@react-stately/list';

import { useOption } from '@react-aria/listbox';

import { StyledOption } from './styled';

type ListState = ReturnType<typeof useListState>;
type Collection = ListState['collection'];

interface Props {
  item: NonNullable<ReturnType<Collection['getItem']>>;
  state: ListState;
}

export const Option = ({ item, state }: Props) => {
  const ref = useRef<HTMLLIElement>(null);
  const { optionProps, isSelected, isFocused, isDisabled } = useOption(
    { key: item.key },
    state,
    ref
  );

  return (
    <StyledOption
      {...optionProps}
      ref={ref}
      isSelected={isSelected}
      isFocused={isFocused}
      isDisabled={isDisabled}
    >
      {item.rendered}
    </StyledOption>
  );
};
